export default __webpack_public_path__ + "42379e2f7467f8cd8c0c1c9f82ce3c3d.svg";